import { motion } from "framer-motion";
import { FileText, Layers, Search, ListChecks } from "lucide-react";

// Section 01 — "Was ist BeParent" — text-heavy manifesto with a subtle document illustration.
export default function IntroViz() {
  return (
    <div className="relative w-[70%] md:w-full max-w-[520px] mx-auto">
      <div
        aria-hidden
        className="absolute -inset-6 rounded-[32px]"
        style={{
          background:
            "radial-gradient(60% 40% at 40% 30%, rgba(0,250,248,0.12), transparent 70%)",
          filter: "blur(24px)",
        }}
      />
      <div className="relative rounded-[28px] border border-white/5 bg-gradient-to-b from-[#1E293B]/95 to-[#0F172A] p-6 md:p-8">
        {/* Window chrome */}
        <div className="flex items-center justify-between border-b border-white/5 pb-4">
          <div className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full bg-white/10" />
            <span className="h-2.5 w-2.5 rounded-full bg-white/10" />
            <span className="h-2.5 w-2.5 rounded-full bg-white/10" />
          </div>
          <span className="text-[10px] font-mono-bp uppercase tracking-[0.25em] text-white/40">
            beparent · fallakte
          </span>
          <span className="h-2 w-2 rounded-full bg-[#00FAF8] shadow-[0_0_10px_#00FAF8]" />
        </div>

        {/* Body grid */}
        <div className="mt-6 grid grid-cols-12 gap-3">
          {/* Sidebar */}
          <div className="col-span-4 rounded-xl border border-white/5 bg-white/[0.03] p-3 space-y-2">
            {[
              { i: FileText, l: "Ereignisse", active: true },
              { i: Layers, l: "Dokumente" },
              { i: Search, l: "Muster" },
              { i: ListChecks, l: "Berichte" },
            ].map(({ i: Icon, l, active }) => (
              <div
                key={l}
                className={`flex items-center gap-2 rounded-lg px-2 py-1.5 ${
                  active
                    ? "bg-[#00FAF8]/10 border border-[#00FAF8]/25"
                    : "border border-transparent"
                }`}
              >
                <Icon size={11} className={active ? "text-[#00FAF8]" : "text-white/45"} />
                <span
                  className={`text-[10px] font-mono-bp ${
                    active ? "text-[#00FAF8]" : "text-white/60"
                  }`}
                >
                  {l}
                </span>
              </div>
            ))}
          </div>

          {/* Main */}
          <div className="col-span-8 rounded-xl border border-white/5 bg-white/[0.02] p-3">
            <div className="flex items-center justify-between mb-3">
              <span className="text-[10px] font-mono-bp uppercase tracking-widest text-white/40">
                Ereignisse · September
              </span>
              <span className="text-[10px] font-mono-bp text-[#00FAF8]">
                18 Einträge
              </span>
            </div>
            <div className="space-y-1.5">
              {ROWS.map((r, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: -12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.1 }}
                  transition={{
                    delay: 0.05 * i,
                    duration: 0.6,
                    ease: [0.22, 1, 0.36, 1],
                  }}
                  className="flex items-center gap-2 rounded-lg border border-white/5 bg-white/[0.02] px-2 py-1.5"
                >
                  <span
                    className="h-1.5 w-1.5 rounded-full"
                    style={{ background: r.c }}
                  />
                  <span className="text-[10px] text-white/75 flex-1 truncate">
                    {r.t}
                  </span>
                  <span className="text-[9px] font-mono-bp text-white/35">
                    {r.d}
                  </span>
                </motion.div>
              ))}
            </div>

            {/* Footer bar */}
            <div className="mt-3 flex items-center justify-between rounded-lg border border-white/5 bg-white/[0.02] px-2.5 py-2">
              <span className="text-[10px] font-mono-bp text-white/50">
                Analyse
              </span>
              <div className="flex-1 mx-3 h-1 rounded-full bg-white/5 overflow-hidden">
                <motion.div
                  initial={{ width: 0 }}
                  whileInView={{ width: "68%" }}
                  viewport={{ once: true }}
                  transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                  className="h-full bg-[#00FAF8]"
                />
              </div>
              <span className="text-[10px] font-mono-bp text-[#00FAF8]">
                68%
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const ROWS = [
  { t: "Umgangswochenende dokumentiert", d: "01.09", c: "#00FAF8" },
  { t: "Kommunikationsverlauf abgelegt", d: "03.09", c: "#94A3B8" },
  { t: "Kita-Bericht importiert", d: "05.09", c: "#94A3B8" },
  { t: "Ausfall Umgang · Muster erkannt", d: "07.09", c: "#00FAF8" },
  { t: "Bericht Q3 erstellt", d: "09.09", c: "#475569" },
  { t: "Ereignis manuell hinzugefügt", d: "12.09", c: "#94A3B8" },
];
